import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar"; // adjust path if needed
import Homepage from "./pages/Homepage";
import FeaturesPage from "./components/Features";
import HowToUse from "./pages/HowToUse";
import GetStartedPage from "./pages/GetStarted";
import HandKeyboard from "./pages/HandKeyboard"; // add your keyboard page
import About from "./pages/About";
function App() {
  return (
    <Router>
      <Navbar /> {/* <-- make sure Navbar is rendered here */}
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/features" element={<FeaturesPage />} />
        <Route path="/start" element={<GetStartedPage />} />
        <Route path="/keyboard" element={<HandKeyboard />} /> 
        <Route path="/howtouse" element={<HowToUse />} /> 
        <Route path="/about" element={<About />} /> 
      </Routes>
    </Router>
  );
}

export default App;
